import { render, staticRenderFns } from "./ReservedActions.vue?vue&type=template&id=36acb2af&scoped=true&lang=pug"
import script from "./ReservedActions.vue?vue&type=script&lang=js"
export * from "./ReservedActions.vue?vue&type=script&lang=js"
import style0 from "./ReservedActions.vue?vue&type=style&index=0&id=36acb2af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36acb2af",
  null
  
)

export default component.exports